// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Img from "@insite/mobius/Img";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { fontConfig } from "@stoneage/XDL/constants";
import { color } from "@stoneage/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    legendsList?: {
        imgLink: string;
        label: string;
    }[];
}
interface GoogleMapLegendStyles {
    wrapper?: InjectableCss;
    legendTitleWrapper?: TypographyPresentationProps;
    legendInfoWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    legendTitle?: TypographyPresentationProps;
}

export const googleMapLegendStyles: GoogleMapLegendStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            position: absolute;
            top: 60px;
            right: 10px;
            width: 100px;
            padding: 8px;
            background-color: ${color("common.ui3")};
            gap: 12px;
            border: 1px solid ${color("common.ui1")};
        `,
    },
    legendTitleWrapper: {
        ...fontConfig.small,
        weight: fontConfig.weight.bold,
    },
    legendInfoWrapper: {
        css: css`
            display: flex;
            gap: 4px;
            align-items: baseline;
        `,
    },
    imageWrapper: {
        css: css`
            height: 16px;

            > img {
                height: 100%;
                max-height: 100%;
            }
        `,
    },
    legendTitle: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.regular,
        css: css`
            word-break: break-word;
            align-self: flex-end;
        `,
    },
};

const styles = googleMapLegendStyles;
const GoogleMapLegend = ({ legendsList }: OwnProps) => {
    if (!legendsList?.length) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.legendTitleWrapper}>{translate("Legend")}</Typography>
            {legendsList.map(({ imgLink, label }) => (
                <StyledWrapper key={label} {...styles.legendInfoWrapper}>
                    <StyledWrapper {...styles.imageWrapper}>
                        <Img src={imgLink} />
                    </StyledWrapper>
                    <Typography {...styles.legendTitle}>{label} </Typography>
                </StyledWrapper>
            ))}
        </StyledWrapper>
    );
};

export default GoogleMapLegend;
